module.exports = __webpack_public_path__ + "static/kujou-sara-bf11346c726bb239542d093d0f46307f.png";